import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup
} from 'devextreme-react/data-grid';
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { backendlink } from '../../config';
import './PartnerPatientListDatagrid.css';

export default function PartnerPatientListDatagrid() {

    const { user } = useAuth();

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);

    const [formData, setformData] = useState({ startDate: '', endDate: '' });

    const [loadingExport, setLoadingExport] = useState(false);

    function handleRowClick(e) {
        const patientToken = e.data.userToken;

        navigate('/partner-patient-info', { state: { patientToken: patientToken, isPatientVerified: e.data.isVerified, organizationToken: e.data.organizationToken } });
    }

    const onSubmitExport = async (e) => {
        e.preventDefault();

        setLoadingExport(true);

        var currentDate = new Date();
        var currentDateString = currentDate.getFullYear() + (((currentDate.getMonth()+1) < 10) ? ('0' + (currentDate.getMonth()+1)) : (currentDate.getMonth()+1)) + (((currentDate.getDate()) < 10) ? ('0' + (currentDate.getDate())) : (currentDate.getDate()))
        var fileName = 'vitopro_partner_Log_' + currentDateString;

        var startDateString = formData.startDate.getFullYear() + '-' + (((formData.startDate.getMonth()+1) < 10) ? ('0' + (formData.startDate.getMonth()+1)) : (formData.startDate.getMonth()+1)) + '-' + (((formData.startDate.getDate()) < 10) ? ('0' + (formData.startDate.getDate())) : (formData.startDate.getDate())) + 'T00:00:00.000Z'
        var endDateString = formData.endDate.getFullYear() + '-' + (((formData.endDate.getMonth()+1) < 10) ? ('0' + (formData.endDate.getMonth()+1)) : (formData.endDate.getMonth()+1)) + '-' + (((formData.endDate.getDate()) < 10) ? ('0' + (formData.endDate.getDate())) : (formData.endDate.getDate())) + 'T23:59:59.000Z'

        try {
            const response = await axios.post(backendlink + 'partner/exportpatientlogs',

            {
                startdate: startDateString,
                enddate: endDateString,
                usertoken: user.userToken
            }, 
            {
                headers: {
                    token: user.token
                },
                responseType: 'blob' // set the response type to blob 
            }).then((res)=>{
                setLoadingExport(false);

                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName + '.xlsx');
                document.body.appendChild(link);
                link.click();
            });
        } catch (error) {
            setLoadingExport(false);

            console.log(error);
            alert(error);
        }
    }


    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.post(
            backendlink + "partner/getallpatients",
            {
              usertoken: user.userToken,
            },
            {
              headers: {
                token: user.token,
              },
            }
          );
          if (response.data.errorno === 0) {
            const outputArray = response.data.result[0].map((item) => {
              var statusString = item.isEnabled == true ? "Active" : "Inactive";

              return {
                name: item.name,
                email: item.email,
                status: statusString,
                linkedCustomer: item.linkedcustomer,
                linkedDoctor: item.linkeddoctor,
                userToken: item.userToken,
                isVerified: item.isVerified,
                organizationToken: item.organizationToken
              };
            });
            setUsers(outputArray);
          } else if (response.data.errorno == 330) {
            setUsers([]);
          } else {
            alert(response.data.errmessage);
          }
        } catch (error) {
          alert(error);
        }
      };

      fetchData();

      var dateStartdate = new Date(Date.now() - 86400000);
      var dateEnddate = new Date();

      setformData({ startDate: dateStartdate, endDate: dateEnddate });
    }, [user]);

  return (
    <React.Fragment>
        <DataGrid dataSource={users} onRowClick={handleRowClick}>
            <Column dataField="name"  caption='Patient' />
            <Column dataField="status"  caption='Status' />
            <Column dataField='email'  caption='Contact Email' />
            <Column dataField="linkedCustomer" caption='Linked Organization' />
            <Column dataField="linkedDoctor" caption='Linked Doctor' />
            <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
            <Paging defaultPageSize={5} />
            <FilterRow visible={true} />
            <Lookup />
        </DataGrid>
    </React.Fragment>
  )

}
